import { TagFolderDelimitter } from '@standardnotes/models';
import { lastElement, sortByKey, withoutLastElement } from '@standardnotes/utils';
import { ContentType } from '@standardnotes/domain-core';
export class TagsToFoldersMigrationApplicator {
    static isApplicableToCurrentData(itemManager) {
        const tags = itemManager.getItems(ContentType.TYPES.Tag);
        for (const tag of tags) {
            if (tag.title.includes(TagFolderDelimitter) && !tag.parentId) {
                return true;
            }
        }
        return false;
    }
    static async run(itemManager, mutator) {
        const tags = itemManager.getItems(ContentType.TYPES.Tag);
        const sortedTags = sortByKey(tags, 'title');
        for (const tag of sortedTags) {
            const hierarchy = tag.title.split(TagFolderDelimitter);
            const hasSimpleTitle = hierarchy.length === 1;
            const hasParent = !!tag.parentId;
            const hasUnsupportedTitle = hierarchy.some((title) => title.length === 0);
            if (hasParent || hasSimpleTitle || hasUnsupportedTitle) {
                continue;
            }
            const parents = withoutLastElement(hierarchy);
            const newTitle = lastElement(hierarchy);
            if (!newTitle) {
                return;
            }
            const parent = await mutator.findOrCreateTagParentChain(parents);
            await mutator.changeItem(tag, (mutator) => {
                mutator.title = newTitle;
                if (parent) {
                    mutator.makeChildOf(parent);
                }
            });
        }
    }
}
